import React from 'react';
import styled from 'styled-components';

const DeactivateButton = ({ onClick, disabled, isDeactivated, children }) => {
    return (
        <ButtonContainer 
            onClick={onClick} 
            disabled={disabled || isDeactivated}
            isDeactivated={isDeactivated}
        >
            {children || (isDeactivated ? 'Deactivated' : 'Deactivate')}
        </ButtonContainer>
    );
};

const ButtonContainer = styled.button`
    color: ${props => props.isDeactivated ? '#9CA3AF' : '#344054'};
    text-align: center;
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    display: flex;
    width: ${props => props.isDeactivated ? '111px' : '102px'};
    height: 42px;
    padding: 0;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    border-radius: 10px;
    border: 1px solid #D0D5DD;
    background: ${props => props.isDeactivated ? '#F3F4F6' : '#FFF'};
    cursor: ${props => props.isDeactivated ? 'not-allowed' : 'pointer'};
    transition: all 0.2s ease;
    white-space: nowrap;

    &:hover:not(:disabled) {
        background: ${props => props.isDeactivated ? '#F3F4F6' : '#F9FAFB'};
        border-color: ${props => props.isDeactivated ? '#D0D5DD' : '#98A2B3'};
    }

    &:active:not(:disabled) {
        background: ${props => props.isDeactivated ? '#F3F4F6' : '#F2F4F7'};
    }

    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }
`;

export default DeactivateButton;

